import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { to: "/", label: "Home", id: "nav-link-home" },
  { to: "/servizi", label: "Servizi", id: "nav-link-servizi" },
  { to: "/come-funziona", label: "Come funziona", id: "nav-link-come-funziona" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-paper/90 backdrop-blur" data-testid="header">
      <div className="container-site flex h-16 items-center justify-between md:h-[76px]">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex" aria-label="Navigazione principale">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-petrolio" : "text-antracite-soft hover:text-petrolio"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/richiedi-valutazione"
            data-testid="nav-cta-button"
            className="rounded-full bg-petrolio px-5 py-2.5 text-sm font-semibold text-paper transition-all duration-300 hover:bg-petrolio-deep hover:shadow-[0_8px_24px_rgba(23,63,58,0.25)]"
          >
            Richiedi una valutazione
          </Link>
        </nav>
        <button
          type="button"
          className="grid h-10 w-10 place-items-center rounded-lg text-antracite transition-colors hover:bg-fog md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          data-testid="mobile-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav
          className="border-t border-line bg-paper px-5 pb-6 pt-2 md:hidden"
          aria-label="Menu"
          data-testid="mobile-menu"
        >
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-${l.id}`}
              end={l.to === "/"}
              className={({ isActive }) =>
                `block rounded-lg px-3 py-3 text-base font-medium transition-colors ${
                  isActive ? "bg-fog text-petrolio" : "text-antracite hover:bg-fog"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/richiedi-valutazione"
            data-testid="mobile-nav-cta-button"
            className="mt-3 block rounded-full bg-petrolio px-5 py-3 text-center text-sm font-semibold text-paper"
          >
            Richiedi una valutazione gratuita
          </Link>
        </nav>
      )}
    </header>
  );
}
